/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Model_DownloadedInputs */

const en_offline_sync_model_downloaded = /** @type {(inputs: Offline_Sync_Model_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model downloaded`)
};

const fr_offline_sync_model_downloaded = /** @type {(inputs: Offline_Sync_Model_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèle téléchargé`)
};

const de_offline_sync_model_downloaded = /** @type {(inputs: Offline_Sync_Model_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modell heruntergeladen`)
};

const it_offline_sync_model_downloaded = /** @type {(inputs: Offline_Sync_Model_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modello scaricato`)
};

const ru_offline_sync_model_downloaded = /** @type {(inputs: Offline_Sync_Model_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Модель загружена`)
};

const es_offline_sync_model_downloaded = /** @type {(inputs: Offline_Sync_Model_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo descargado`)
};

const zh_cn2_offline_sync_model_downloaded = /** @type {(inputs: Offline_Sync_Model_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模型已下载`)
};

const ja_offline_sync_model_downloaded = /** @type {(inputs: Offline_Sync_Model_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モデルをダウンロード済み`)
};

const hi_offline_sync_model_downloaded = /** @type {(inputs: Offline_Sync_Model_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मॉडल डाउनलोड हो गया`)
};

const pt_pt2_offline_sync_model_downloaded = /** @type {(inputs: Offline_Sync_Model_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo transferido`)
};

/**
* | output |
* | --- |
* | "Model downloaded" |
*
* @param {Offline_Sync_Model_DownloadedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_model_downloaded = /** @type {((inputs?: Offline_Sync_Model_DownloadedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Model_DownloadedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_model_downloaded(inputs)
	if (locale === "de") return de_offline_sync_model_downloaded(inputs)
	if (locale === "it") return it_offline_sync_model_downloaded(inputs)
	if (locale === "ru") return ru_offline_sync_model_downloaded(inputs)
	if (locale === "es") return es_offline_sync_model_downloaded(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_model_downloaded(inputs)
	if (locale === "ja") return ja_offline_sync_model_downloaded(inputs)
	if (locale === "hi") return hi_offline_sync_model_downloaded(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_model_downloaded(inputs)
	return en_offline_sync_model_downloaded(inputs)
});